/* RIVOR — the product gallery is a sideways strip.

   rivor.js still marks the current shot by putting .is-active on it, for
   thumbnail clicks and colourway switches alike. Rather than duplicate that
   logic, watch for the class and scroll to whatever it lands on, then keep
   the thumbnails in step while the strip is swiped by hand. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  [].forEach.call(document.querySelectorAll('[data-gallery]'), function (gallery) {
    var root = gallery.closest('[data-product]') || document;
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));

    function panels() {
      return [].slice.call(gallery.querySelectorAll('[data-media-id]'));
    }

    function scrollToPanel(panel, smooth) {
      if (!panel) return;
      var left = panel.offsetLeft - gallery.offsetLeft;
      if (Math.abs(gallery.scrollLeft - left) < 2) return;
      try {
        gallery.scrollTo({ left: left, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
      } catch (e) {
        gallery.scrollLeft = left;
      }
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var el = records[i].target;
          if (el.classList && el.classList.contains('is-active') && el.hasAttribute('data-media-id')) {
            scrollToPanel(el, true);
            return;
          }
        }
      }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var settle;
    gallery.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var list = panels();
        if (!list.length || !gallery.clientWidth) return;
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        var current = list[Math.max(0, Math.min(index, list.length - 1))];
        if (!current) return;
        var id = current.getAttribute('data-media-id');
        thumbs.forEach(function (thumb) {
          thumb.setAttribute('aria-selected', thumb.getAttribute('data-thumb') === id ? 'true' : 'false');
        });
      }, 90);
    }, { passive: true });

    scrollToPanel(gallery.querySelector('[data-media-id].is-active'), false);
  });
})();

/* RIVOR — sticky buy bar on small screens.

   On a 375px phone the inline Add to bag sits below the fold, so mirror it in
   a bar pinned to the bottom that appears once the real button scrolls away.
   It drives the real button rather than duplicating any cart logic. */
(function () {
  'use strict';

  if (!window.matchMedia('(max-width: 900px)').matches) return;

  var form = document.querySelector('.js-product-form');
  var addBtn = document.querySelector('[data-add]');
  if (!form || !addBtn) return;

  var priceEl = document.querySelector('[data-price]');

  var bar = document.createElement('div');
  bar.className = 'buybar';
  var price = document.createElement('span');
  price.className = 'buybar-price';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn';
  bar.appendChild(price);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  function sync() {
    price.textContent = priceEl ? priceEl.textContent.trim() : '';
    btn.textContent = (addBtn.textContent || '').trim() || 'Add to bag';
    btn.disabled = addBtn.disabled;
  }
  sync();
  new MutationObserver(sync).observe(form, {
    subtree: true, childList: true, characterData: true, attributes: true
  });

  btn.addEventListener('click', function () { addBtn.click(); });

  /* Show the bar whenever the real button is off screen. Driven by scroll and
     resize rather than IntersectionObserver, so it also reacts to the viewport
     changing (address bar collapsing, rotation) and is testable directly. */
  var queued = false;
  function update() {
    queued = false;
    var r = addBtn.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    bar.classList.toggle('is-on', r.bottom < 0 || r.top > h);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  update();
})();
